// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar__root--HK85N"};